// import { OrdenServicio } from "./ordenServicio";
// import { Unidad } from "./unidad";

// export class DatosOrdenServicio {
//     ordenServicio: OrdenServicio;
//     unidad: Unidad;

//     constructor() {
//         this.ordenServicio = new OrdenServicio();
//         this.unidad = new Unidad();
//     }
// }

export class DatosOrdenServicio {
    idOrdenServicio: number;
    ordenServicio: string;
    proceso: string;
    tipoServicio: string;
    aseguradora: string;
    cliente: string;
    fechaIngreso: Date;
    fechaPromesa: Date;
    magnitud: string;
    tipoUnidad: string;
    marca: string;
    modelo: string;
    poliza: string;
    reporte: string;
    economico: string;
    deducible: number;
    demerito: number;
    placa: string;
    serie: string;
    kmEntrada: number;
    kKmSalida: number;
    gasolina: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/datosOrdenServicio.ts